import { api } from '../../http';
import { AssetType } from '../../types/interfaces';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';

import Api from './api';
import IAssetTypesApi from './interfaces/assetTypesApi';

class AssetTypesApi extends Api<AssetType> implements IAssetTypesApi {
  constructor(abortController: AbortController) {
    super('assetType/', abortController);
  }

  async getForSelection() {
    const apiCallResult = await api.get<ObjectForSelection[]>(
      'assetType/getForSelection',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default AssetTypesApi;
